import { makeStyles } from "@material-ui/core/styles";
const useDashboardStyles = makeStyles({
  card: {
    cursor: "pointer",
    minWidth: "304px",
    minHeight: "210px",
    maxWidth: "304px",
    maxHeight: "210px",
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "26px",
    padding: "16px",
    "& .wrapper": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
      background:
        "linear-gradient(90deg, rgba(6, 156, 240, 0.02) 0%, rgba(6, 156, 240, 0.14) 47.71%, rgba(6, 156, 240, 0.02) 100%)",
      borderRadius: "20px",
      position: "relative",
      padding: "10px",
      textAlign: "center",
      gap: "30px",
      "& img": {
        width: "40px",
        height: "40px",
      },
      "& .actionIcon": {
        position: "absolute",
        top: "10px",
        insetInlineEnd: "10px",
      },
      "& p": {
        margin: 0,
        width: "80%",
      },
      "& .sharedIcon": {
        position: "absolute",
        top: "15px",
        insetInlineStart: "10px",
      },
    },
  },
});
export default useDashboardStyles;
